import { render, staticRenderFns } from "./SpaceHIcon.vue?vue&type=template&id=89e6c978&"
import script from "./SpaceHIcon.vue?vue&type=script&lang=js&"
export * from "./SpaceHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports